'use client';

import { ProgressSpinner } from 'primereact/progressspinner';

interface LoadingSpinnerProps {
  message?: string;
  size?: number;
  className?: string;
  containerHeight?: string;
}

export default function LoadingSpinner({
  message = 'Loading...',
  size = 50,
  className = '',
  containerHeight = 'h-[400px]',
}: LoadingSpinnerProps) {
  return (
    <div className={`w-full ${containerHeight} flex items-center justify-center ${className}`}>
      <div className="text-center">
        <ProgressSpinner style={{ width: `${size}px`, height: `${size}px` }} />
        <p className="mt-4 text-gray-600">{message}</p>
      </div>
    </div>
  );
}
